import * as React from "react";
import {isEmpty as _isEmpty} from "lodash";
import { HabitPrescriptionItemRequest, PrescriptionItemGuideline } from "@curefit/gmf-common";
import {default as CustomHeader, ICustomHeaderInfo} from "../../utils/CustomHeader";
import AppUtils from "../../../utils/AppUtils";

export interface HabitsPlanViewProps {
    patientHabitsPlan: HabitPrescriptionItemRequest[]
}

const PatientHabitsPlansViewHeaderInfos: ICustomHeaderInfo[] = [
    {label: "dailyHabit", display: "DAILY HABIT"},
    {label: "frequency", display: "FREQUENCY"},
    {label: "condition", display: "ADVICE"}
];

const GuidelinesHeaderInfos: ICustomHeaderInfo[] = [
    {label: "guidelines", display: "GUIDELINES"}
]

export default class HabitsPlanView extends React.Component<HabitsPlanViewProps> {

    render () {
        const hasHabitsPlanData = !_isEmpty(this.props.patientHabitsPlan);
        const habitsActivitiesData = hasHabitsPlanData && !_isEmpty(this.props.patientHabitsPlan.habitList) ? this.props.patientHabitsPlan.habitList : [];
        const habitsGuidelinesData = hasHabitsPlanData && !_isEmpty(this.props.patientHabitsPlan.guidelines) ? this.props.patientHabitsPlan.guidelines : [];
        return (
            <div className={"habits-plan-view-container"}>
                {
                    !_isEmpty(habitsGuidelinesData) &&
                    <div>
                        <CustomHeader headerInfos={GuidelinesHeaderInfos} rootCls={"patient-fitness-plan"}/>
                        {
                            habitsGuidelinesData.map((item: string, index: number) => {
                                return (
                                    <div key={`fitnessGuidelineItem-${index}`}>{item}</div>
                                )
                            })
                        }
                    </div>
                }
                {
                    !_isEmpty(habitsActivitiesData) &&
                    <div>
                        <CustomHeader headerInfos={PatientHabitsPlansViewHeaderInfos} rootCls={"patient-habitsPlan"}/>
                        {
                            habitsActivitiesData.map((item: any, index: number) => {
                                const lifestyleAdviceItem = !_isEmpty(item.dailyHabit) ? item.dailyHabit.displayValue : null;
                                let frequency = !_isEmpty(item.frequency) ? item.frequency : null;
                                let habitComment = !_isEmpty(item.advice) ? item.advice : null;
                                return (
                                    <div className={`habits-plan-item-view`}>
                                        <div className={`smart-column habits-plan-item-editor-dailyHabit`}>
                                            <span>{lifestyleAdviceItem}</span>
                                        </div>
                                        <div className="smart-column habits-plan-item-editor-frequency">
                                            <span>{AppUtils.getFrequencyText(frequency, true)}</span>
                                        </div>
                                        <div className="smart-column habits-plan-item-editor-condition">
                                            <span>{habitComment}</span>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                }
                {
                    _isEmpty(habitsActivitiesData) &&
                    <div className={"no-habits-label"}>No Habits to show</div>
                }
            </div>
        )
    }
}